module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header"
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('button', {
    staticClass: "mobile-menu-btn",
    on: {
      "click": function($event) {
        return _vm.$emit('toggle-mobile-menu')
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("menu")])]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "search-field"
  }, [_c('span', {
    staticClass: "material-symbols-outlined search-icon"
  }, [_vm._v("search")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "search-input",
    attrs: {
      "type": "text",
      "placeholder": "Suche..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "search-underline"
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "notification-container",
    on: {
      "click": _vm.showNotifications
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined notification-icon"
  }, [_vm._v("notifications")]), _vm._v(" "), _c('div', {
    staticClass: "notification-badge"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: (_vm.closeUserMenu),
      expression: "closeUserMenu"
    }],
    staticClass: "user-profile",
    on: {
      "click": _vm.toggleUserMenu
    }
  }, [_c('div', {
    staticClass: "user-info"
  }, [_c('div', {
    staticClass: "user-name"
  }, [_vm._v(_vm._s(_vm.userDisplayName))]), _vm._v(" "), _c('div', {
    staticClass: "user-role"
  }, [_vm._v(_vm._s(_vm.userDisplayType))])]), _vm._v(" "), _c('span', {
    staticClass: "user-avatar material-symbols-outlined "
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('span', {
    staticClass: "mobile-avatar material-symbols-outlined"
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUserDropdown),
      expression: "showUserDropdown"
    }],
    staticClass: "user-dropdown"
  }, [_c('div', {
    staticClass: "dropdown-header"
  }, [_c('span', {
    staticClass: "material-symbols-outlined dropdown-avatar"
  }, [_vm._v("account_circle")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-user-info"
  }, [_c('div', {
    staticClass: "dropdown-user-name"
  }, [_vm._v(_vm._s(_vm.userDisplayName))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-user-role"
  }, [_vm._v(_vm._s(_vm.userDisplayType))])])]), _vm._v(" "), _c('hr', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu-item",
    on: {
      "click": function($event) {
        return _vm.$emit('show-language-dialog')
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("public")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.A0006) + " (" + _vm._s(_vm.languageList ? _vm.languageList[_vm.globals.selectedLanguage] : '') + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu-item",
    on: {
      "click": function($event) {
        return _vm.navigate('/settings', _vm.lang.A0024)
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("settings")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.A0024))])]), _vm._v(" "), _c('hr', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu-item",
    on: {
      "click": function($event) {
        return _vm.$emit('user-logout')
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("logout")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.lang.A0003))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mobile-search-btn"
  }, [_c('span', {
    staticClass: "material-symbols-outlined"
  }, [_vm._v("search")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9fb906fe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppHeaderAlternative.vue
// module id = 1714
// module chunks = 1